import Form from './Form.vue';
import FormLabel from './FormLabel.vue';
import FormSection from './FormSection.vue';
import StepperForm from './StepperForm.vue';
import StepperFormSection from './StepperFormSection.vue';
import Wizard from './Wizard.vue';

export default [
  Form,
  FormLabel,
  FormSection,
  StepperForm,
  StepperFormSection,
  Wizard,
];
